import React, { useState, useRef, useEffect } from "react";
import { qiniuService } from "../../services/qiniu.service";
import { message, Upload, Button, Progress } from "antd";
import { PlusOutlined, CloseCircleOutlined } from "@ant-design/icons";
import "./index.scss";

const UploadImage = (props) => {
  const [image, setImage] = useState(props.src); // 用于存储黏贴的图片
  const [uploading, setUploading] = useState(false); // 用于控制上传状态
  const [uploadProgress, setUploadProgress] = useState({}); // 用于存储上传进度
  const inputFileRef = useRef(null);

  useEffect(() => {
    setImage(props.src);
  }, [props.src]);

  const handleButtonClick = () => {
    if (inputFileRef.current) inputFileRef.current.click?.();
  };

  const uploadRequest = async ({ file, onSuccess, onError, onProgress }) => {
    try {
      setUploading(true);
      // Notify parent component that upload has started
      props.onUploadStart?.();

      const result = await qiniuService.uploadFile({
        file,
        onProgress: (progress) => {
          setUploadProgress((prev) => ({
            ...prev,
            [file.uid]: progress.percent,
          }));
          onProgress(progress);
        },
      });
      onSuccess?.(result);
      setUploading(false); // 清空上传进度
      setImage(result.url); // 设置图片 URL
      props.onSuccess?.(result); // 确保在设置图片后再调用onSuccess
      message.success("上传成功");
    } catch (error) {
      onError(error);
      setUploading(false); // 清空上传进度
      message.error(error.message || "上传失败");
    }
  };

  // 处理文件选择
  const onInputFileChange = async (e) => {
    const files = e.target.files ?? [];
    if (!files.length) return;
    handleUpload(files[0]);
    e.target.value = null;
  };

  // 黏贴图片
  const handlePaste = (event) => {
    const clipboardItems = event.clipboardData.items;
    console.log(clipboardItems);
    if (clipboardItems.length === 0) return;
    const file = clipboardItems[0].getAsFile();
    handleUpload(file);
  };

  // 开始上传
  const handleUpload = (file) => {
    if (!file?.type?.startsWith("image/")) {
      message.error("请拖拽图片文件");
      return;
    }
    const imageUrl = URL.createObjectURL(file); // 创建图片的临时 URL
    setImage(imageUrl); // 设置图片 URL
    uploadRequest({
      file,
      onSuccess: (result) => {
        setImage(result.url);
        URL.revokeObjectURL(imageUrl);
      },
      onError: () => URL.revokeObjectURL(imageUrl),
      onProgress: () => URL.revokeObjectURL(imageUrl),
    }); // 上传图片并释放临时 URL
  };

  // 清除图片
  const clearImage = (e) => {
    e.stopPropagation();
    setImage(null);
    props.onSuccess?.({
      url: null,
    });
  };

  // 拖拽上传相关
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  // 处理拖拽放下事件
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const files = e.dataTransfer.files;
    if (!files || !files.length) return;
    if (files.length > 1) {
      message.error("只支持单次上传一个文件");
      return;
    }
    const file = files[0];
    handleUpload(file);
  };

  return (
    <div
      className="fullUploader"
      onPaste={handlePaste}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      <input
        ref={inputFileRef}
        type="file"
        accept="image/*"
        onChange={onInputFileChange}
        className="inputWrapper"
      ></input>
      {image
        ? [
            <img
              key="image"
              src={image}
              alt="上传图片"
              className="imageWrapper"
            />,
            <div className="titleLine">
              <div className="label">{props.title}</div>
              <div className="clearBtn" onClick={clearImage}>
                <CloseCircleOutlined />
              </div>
            </div>,
          ]
        : [
            <div className="titleLine empty">
              <div className="label">{props.title}</div>
            </div>,
            <Button className="uploadBtn" onClick={handleButtonClick}>
              <PlusOutlined className="icon" />
              点击/拖拽到此处上传
            </Button>,
            <div className="hintLabel">
              或此区域按 <strong>Ctrl+V</strong> 黏贴图片
            </div>,
          ]}

      {/* Add progress bar */}
      {Object.keys(uploadProgress).length > 0 &&
        uploadProgress[Object.keys(uploadProgress)[0]] < 100 && (
          <Progress
            key="progress"
            percent={Math.round(uploadProgress[Object.keys(uploadProgress)[0]])}
            size="small"
            status="active"
            style={{
              position: "absolute",
              bottom: "10px",
              left: "10px",
              right: "10px",
            }}
          />
        )}
    </div>
  );
};

export default UploadImage;
